import { PUBLIC_TOKENS } from "../core/constants.js";

export const DEFAULT_THEME = {
  [PUBLIC_TOKENS.workspaceBg]: "rgba(0, 0, 0, 0)",
  [PUBLIC_TOKENS.windowBg]: "#eef1f5",
  [PUBLIC_TOKENS.panelBg]: "#f8fafc",
  [PUBLIC_TOKENS.titlebarActiveBg]: "rgba(46, 92, 142, 0.78)",
  [PUBLIC_TOKENS.titlebarInactiveBg]: "rgba(136, 145, 160, 0.84)",
  [PUBLIC_TOKENS.titlebarFg]: "#f8fbff",
  [PUBLIC_TOKENS.borderStrong]: "#232a33",
  [PUBLIC_TOKENS.borderSubtle]: "#9ba5b3",
  [PUBLIC_TOKENS.focusRing]: "#154fbc",
  [PUBLIC_TOKENS.buttonBg]: "#f1f4f8",
  [PUBLIC_TOKENS.buttonFg]: "#111720",
  [PUBLIC_TOKENS.buttonActiveBg]: "#dbe3ee",
  [PUBLIC_TOKENS.inputBg]: "#ffffff",
  [PUBLIC_TOKENS.inputFg]: "#111720",
  [PUBLIC_TOKENS.menuBg]: "#f8fbff",
  [PUBLIC_TOKENS.menuFg]: "#0e1621",
  [PUBLIC_TOKENS.selectionBg]: "#1f5eae",
  [PUBLIC_TOKENS.selectionFg]: "#f2f8ff",
  [PUBLIC_TOKENS.statusbarBg]: "#e5e8ee",
  [PUBLIC_TOKENS.appShellBg]: "#eef1f5",
  [PUBLIC_TOKENS.surfaceRaisedBg]: "#ffffff",
  [PUBLIC_TOKENS.surfaceInsetBg]: "#e7ebf1",
  [PUBLIC_TOKENS.textMuted]: "#586272",
  [PUBLIC_TOKENS.textHelp]: "#657184",
  [PUBLIC_TOKENS.dividerColor]: "#c3cad4",
  [PUBLIC_TOKENS.infoBg]: "#e7f0ff",
  [PUBLIC_TOKENS.infoFg]: "#123d7a",
  [PUBLIC_TOKENS.infoBorder]: "#7aa6e8",
  [PUBLIC_TOKENS.successBg]: "#e5f5eb",
  [PUBLIC_TOKENS.successFg]: "#195b34",
  [PUBLIC_TOKENS.successBorder]: "#72b98b",
  [PUBLIC_TOKENS.warningBg]: "#fff4d6",
  [PUBLIC_TOKENS.warningFg]: "#6d4b00",
  [PUBLIC_TOKENS.warningBorder]: "#d9ad3b",
  [PUBLIC_TOKENS.dangerBg]: "#ffe8e6",
  [PUBLIC_TOKENS.dangerFg]: "#8a1f17",
  [PUBLIC_TOKENS.dangerBorder]: "#d46a60",
  [PUBLIC_TOKENS.overlayBackdrop]: "rgba(12, 18, 28, 0.38)",
  [PUBLIC_TOKENS.overlayShadow]: "0 18px 44px rgba(0, 0, 0, 0.24)",
  [PUBLIC_TOKENS.cardBg]: "#fbfcfe",
  [PUBLIC_TOKENS.cardSelectedBg]: "#e8f1ff",
  [PUBLIC_TOKENS.metricBg]: "#ffffff",
  [PUBLIC_TOKENS.codeBg]: "#e8edf4",
  [PUBLIC_TOKENS.codeFg]: "#172131",
  [PUBLIC_TOKENS.shadowDepth]: "0 12px 32px rgba(0, 0, 0, 0.18)",
  [PUBLIC_TOKENS.frostOpacity]: "0.9",
  [PUBLIC_TOKENS.space1]: "4px",
  [PUBLIC_TOKENS.space2]: "8px",
  [PUBLIC_TOKENS.space3]: "12px",
  [PUBLIC_TOKENS.controlHeight]: "30px",
  [PUBLIC_TOKENS.titleHeight]: "32px"
};
